import { Icon } from '@eventbrite/eds-icon';
import React from 'react';
import { useGlobalNavContext } from '../../../../../state';
import { DropdownItem } from '../../../../types';
import styles from './SimpleDropdownItem.module.scss';

const SimpleDropdownItem = ({
    path = '',
    iconType,
    text,
    textColor,
    classes,
}: DropdownItem) => {
    const customStyles: React.CSSProperties = textColor
        ? { color: textColor }
        : {};
    const { env } = useGlobalNavContext();
    return (
        <li tabIndex={0} className={classes}>
            <a
                href={new URL(path, env?.serverUrl ?? '').href}
                tabIndex={-1}
                className={styles.simpleDropdownItem}
                style={customStyles}
            >
                {iconType ? (
                    <span className={styles.iconContainer}>
                        <Icon type={iconType} size="small" />
                    </span>
                ) : null}
                {text}
            </a>
        </li>
    );
};

export default SimpleDropdownItem;
